import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  // Redirect,
  // useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./lib";

import { grained } from "./utils/grained";
import GlobalFonts from "./assets/styles/fonts";
import { Map } from "./components";
import { Home, Chapter } from "./containers";
import Quick from "./containers/QuickContainer";

const grainedOptions = {
  animate: true,
  patternWidth: 500,
  patternHeight: 500,
  grainOpacity: 0.15,
  grainDensity: 1,
  grainWidth: 0.75,
  grainHeight: 0.75,
};

function App() {
  useEffect(() => {
    grained("#grained", grainedOptions);
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <GlobalFonts />

        <div data-testid="app" className="App" id="grained">
          {/* <Ticker /> */}
          <Switch>
            <Route exact path="/black-owned" render={() => <Map />} />
            <Route exact path="/story" render={() => <Quick />} />
            <Route
              exact
              path="/chapters"
              render={({ history }) => <Chapter history={history} />}
            />
            <Route
              exact
              path="/"
              render={({ history }) => <Home history={history} />}
            />
          </Switch>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
